import Vue from 'vue'
import { API_URL } from '@/config'
import router from '@/router'

export const room = {

  namespaced: true,

  state: {
    room: {},
    comments: false,
  },

  getters: {
    room: state => state.room,
    comments: state => state.comments,
  },

  mutations: {
    setRoom(state, room) { state.room = room },
    setComments(state, comments) { state.comments = comments },
    setPublish(state, publish) { state.room.publish = publish },
  },

  actions: {

    getOptions: () => Vue.axios.get(API_URL + '/entities', { params: {
      models: ['App\\Models\\Room'],
      filter_display: true,
    }}),

    async getRoom({ commit }) { 
      const room = await Vue.axios.get(API_URL + '/rooms/' + router.currentRoute.params.id);
      commit('setProgress', false, { root: true });
      commit('setRoom', room.data);
    },

    toggleComments({ state, commit }) {
      commit('setComments', !state.comments);
    },

  }
}
